/* cart-ajax.js */
/* Tacito: smooth cart quantity updates without page reload */

(function () {
  'use strict';

  // Prevent double init
  if (window.__tacitoCartAjaxInit) return;
  window.__tacitoCartAjaxInit = true;

  var FORM_SELECTOR = 'form[action="/cart"]';
  var QTY_SELECTOR = 'input[name="updates[]"]';

  // Common subtotal total selectors across older Shopify themes
  var SUBTOTAL_SELECTORS = [
    '[data-cart-subtotal]',
    '.cart__subtotal',
    '.cart-subtotal',
    '.cart__subtotal-price',
    '.cart__total',
    '.cart__total-price',
    '.cart__final-price',
    '#CartSubtotal',
    '#cart-subtotal',
    '#cartSubtotal',
    '#CartTotal',
    '#cart-total',
    '#CartTotalPrice',
    '#cart-total-price'
  ];

  // Optional: cart count selectors (header bubble)
  var COUNT_SELECTORS = [
    '[data-cart-count]',
    '.site-header__cart-count',
    '.cart-count',
    '.header-cart__count',
    '.ajax-cart__count'
  ];

  var busy = false;
  var timer = null;
  var lastValueByInputId = Object.create(null);

  function getForm() {
    return document.querySelector(FORM_SELECTOR);
  }

  function getQtyInputs() {
    return Array.prototype.slice.call(document.querySelectorAll(QTY_SELECTOR));
  }

  function getLineIndex(input) {
    var inputs = getQtyInputs();
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i] === input) return i + 1;
    }
    return null;
  }

  function getQty(input) {
    var v = input.value;
    if (v === '' || v === null || typeof v === 'undefined') return null;
    var n = parseInt(String(v), 10);
    if (isNaN(n)) return null;
    if (n < 0) n = 0;
    return n;
  }

  function formatMoneyCents(cents) {
    var amount = (cents || 0) / 100;

    try {
      return new Intl.NumberFormat('lv-LV', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    } catch (e) {
      return '€' + amount.toFixed(2);
    }
  }

  function setText(el, text) {
    if (!el) return;
    if (el.textContent !== text) el.textContent = text;
  }

  function updateSubtotal(cart) {
    var text = formatMoneyCents(cart.total_price);
    for (var i = 0; i < SUBTOTAL_SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(SUBTOTAL_SELECTORS[i]);
      if (!nodes || !nodes.length) continue;
      for (var j = 0; j < nodes.length; j++) {
        setText(nodes[j], text);
      }
    }
  }

  function updateCount(cart) {
    var text = String(cart.item_count || 0);
    for (var i = 0; i < COUNT_SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(COUNT_SELECTORS[i]);
      if (!nodes || !nodes.length) continue;
      for (var j = 0; j < nodes.length; j++) {
        setText(nodes[j], text);
      }
    }
  }

  function updateLinePricesIfPossible(cart) {
    // Best-effort only. We do not rerender the cart, we just update totals reliably.
    // Some themes use line price elements with data-line-price or similar.
    var inputs = getQtyInputs();
    for (var i = 0; i < inputs.length; i++) {
      var row = inputs[i].closest && inputs[i].closest('.cart__row, .cart__row--table, .cart-row, .cart__item');
      if (!row) continue;

      var priceEl =
        row.querySelector('[data-line-price]') ||
        row.querySelector('.cart__price') ||
        row.querySelector('.cart__line-price') ||
        row.querySelector('.line-price');

      if (!priceEl) continue;

      if (cart.items && cart.items[i]) {
        setText(priceEl, formatMoneyCents(cart.items[i].final_line_price || cart.items[i].line_price || 0));
      }
    }
  }

  function postChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      }),
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/change failed: ' + res.status);
      return res.json();
    });
  }

  function scheduleUpdate(input) {
    if (!input) return;

    var qty = getQty(input);
    if (qty === null) return;

    var id = input.id || ('idx_' + getLineIndex(input));
    if (lastValueByInputId[id] === qty) return;
    lastValueByInputId[id] = qty;

    if (timer) clearTimeout(timer);

    timer = setTimeout(function () {
      runUpdate(input, qty);
    }, 120);
  }

  function runUpdate(input, qty) {
    if (busy) return;

    var line = getLineIndex(input);
    if (!line) return;

    busy = true;

    postChange(line, qty)
      .then(function (cart) {
        // If cart is truly empty, the theme should show empty cart. Reload once in that case.
        if (cart && typeof cart.item_count === 'number' && cart.item_count === 0) {
          window.location.reload();
          return;
        }

        updateSubtotal(cart);
        updateCount(cart);
        updateLinePricesIfPossible(cart);
      })
      .catch(function () {
        // Fallback: do nothing destructive. Keep the user on the page.
        // If Shopify blocked the request for some reason, a manual refresh still works.
        lastValueByInputId = Object.create(null);
      })
      .finally(function () {
        busy = false;
      });
  }

  function attach() {
    var form = getForm();
    if (!form) return;

    // IMPORTANT: do not allow the form to auto submit because that causes iPhone/iPad jumps.
    form.addEventListener('submit', function (e) {
      var active = document.activeElement;
      if (active && active.matches && active.matches(QTY_SELECTOR)) {
        e.preventDefault();
      }
    });

    function handleQtyEvent(e) {
      var t = e.target;
      if (!t || t.name !== 'updates[]') return;
      scheduleUpdate(t);
    }

    // Works for arrows, paste, and many desktop cases
    form.addEventListener('input', handleQtyEvent, true);

    // Desktop typing reliability
    form.addEventListener('keyup', function (e) {
      var t = e.target;
      if (!t || t.name !== 'updates[]') return;
      if (e.key === 'Enter') return;
      scheduleUpdate(t);
    }, true);

    // If the user clicks away, update immediately
    form.addEventListener('blur', function (e) {
      var t = e.target;
      if (!t || t.name !== 'updates[]') return;
      scheduleUpdate(t);
    }, true);

    // Some themes only trigger change, so we listen too
    form.addEventListener('change', handleQtyEvent, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
